import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'
import { Button } from '@/components/ui/button'

/** Branded route-level error page — replaces React Router's default
 * "Unexpected Application Error!" developer screen for render crashes and
 * unmatched routes. */
export function RouteErrorFallback() {
  const { t } = useTranslation()
  const error = useRouteError()
  useEffect(() => {
    console.error('[router] route error:', error)
  }, [error])
  const isNotFound = isRouteErrorResponse(error) && error.status === 404

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-background px-6 text-center text-foreground">
      <h1 className="font-semibold text-2xl">
        {isNotFound ? t('chat.routeError.notFoundTitle') : t('chat.routeError.title')}
      </h1>
      <p className="max-w-md text-muted-foreground text-sm">
        {isNotFound ? t('chat.routeError.notFoundBody') : t('chat.routeError.body')}
      </p>
      <div className="mt-2 flex gap-2">
        <Button onClick={() => window.location.reload()}>{t('chat.routeError.reload')}</Button>
        <Button variant="outline" asChild>
          <Link to="/cases/home">{t('chat.routeError.goHome')}</Link>
        </Button>
      </div>
    </div>
  )
}
